module.exports = [{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-google-tagmanager@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@9.39.5__7a585effcd3f057bfb4a0b4369b72efa/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-KQ39GK4","includeInDevelopment":false,"defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@9.39.5_jiti@2.7.0_supports-color@11.0.0__suppo_c8bd218768b3ed1a0d92a541b9eeb8b6/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
